<div class="app">
  <app-header></app-header>

  <router-outlet></router-outlet>

  <app-message></app-message>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html